import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';
import ConversationProviders from './modules/ConversationProviders';
import createLogger from 'vuex/dist/logger';

var config = null;

try {
	config = require('../config.js').default;
} catch (err) {
	config = require('../defaultConfig.js').default;
}

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
	...config,
	views: ['Conversation'],
	curViewId: 0,
	plugins: {}
};

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	modules: {
		ConversationProviders
	},
	strict: debug,
	plugins: debug ? [createLogger()] : []
});
